import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.citrinvip-container': {
    '& .normal-text': {
      fontWeight: 300,
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section, .faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        background: palette.background.header,
        '& .hero-header-subtitle, .hero-header-title': {
          color: palette.text.primary,
        },
      },
    '@media(max-width: 900px)': {
      '& .header-wrapper': {
        paddingBottom: '10px',
      },
    },

    '& .checkout-outer-container, .plan-selection-container': {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.background.tertiary,
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '& .hero-title': {
          fontSize: 42,
          fontWeight: 500,
          lineHeight: '55px',
          maxWidth: 500,

          '@media(min-width: 678px)': {
            fontSize: 48,
            lineHeight: '60px',
          },

          '@media(min-width: 900px)': {
            fontSize: 58,
            lineHeight: '80px',
            letterSpacing: '-0.04em',
          },
          '@media (min-width: 768px) and (max-width: 1023px)': {
            maxWidth: 'none',
            textAlign: 'left',
          },
          '@media (min-width: 1024px) and (max-width: 1366)': {
            color: 'red',
          },
        },
        '& .hero-subtitle': {
          fontWeight: 400,
          fontSize: 16,
          lineHeight: '30px',
          maxWidth: 600,
          '@media(min-width: 767px)': {
            fontSize: 18,
          },
          '@media (min-width: 768px) and (max-width: 1024px)': {
            maxWidth: 'none',
            textAlign: 'left',
          },
        },
      },
      '& .section-header__title-wrapper': {
        '@media(max-width: 900px)': {
          display: 'flex',
          justifyContent: 'center',
        },
      },
      '& .image-wrapper': {
        '& .image': {
          boxShadow: 'none',
          height: 'auto',
        },
        '@media(max-width: 900px)': {
          display: 'none',
        },
      },
      '@media(min-width: 900px)': {
        maxHeight: '740px',
      },
      '@media(max-width: 900px)': {
        '& .hero-title, .hero-subtitle': {
          textAlign: 'center',
        },
        '& .section-header__cta-wrapper': {
          '& .section-header__cta-container': {
            '& .section-header__cta-item-wrapper': {
              width: '100%',
              '@media (min-width: 768px) and (max-width: 1024px)': {
                display: 'flex',
              },
            },
          },
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      background: palette.background.subscription,
      '& .subscription-bg': {
        background: palette.background.subscription,
      },
      '& .section-header__title': {
        color: palette.text.highlight,
      },
      '& .section-header__subtitle-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        '& .section-header__subtitle': {
          color: palette.text.highlight,
          maxWidth: '580px',
        },
      },
      '& .subscription-tabs-label': {
        color: palette.text.highlight,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          borderColor: palette.secondary.main,
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            borderColor: palette.secondary.main,
            color: palette.text.primary,
            background: palette.text.highlight,
            '& .customGetStarted': {
              color: palette.text.highlight,
            },
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .price-value': {
            color: palette.text.primary,
            fontWeight: 'bold',
          },
        },
        '& .customGetStarted': {
          color: palette.text.primary,
          '&:hover': {
            color: palette.text.highlight,
          }
        },
        '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
          background: palette.background.light,
          border: `1px solid ${palette.secondary.main}`,
          opacity: 1,
        },
        '& .MuiSwitch-track': {
          border: `1px solid ${palette.secondary.main}`,
          background: palette.text.highlight,
        },
        '& .MuiSwitch-thumb': {
          backgroundColor: palette.secondary.main,
        },
        '& .summary-text, .summary-subtext': {
          color: palette.text.highlight,
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          color: palette.text.highlight,
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .section-header__title': {
        fontWeight: 'normal',
      },
      '& .how-cover-image': {
        height: 450,
      },
      '& .step-counter': {
        backgroundColor: palette.background.steps,
        color: palette.text.highlight,
      },
  
      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },
      '@media(max-width: 900px)': {
        '& .how-cover-image': {
          height: '100%',
        },
      },
      '@media(min-width: 900px)': {
        '& .howitworks-title': {
          marginBottom: 32,
        },
        '& .howitworks-wrapper': {
          paddingLeft: 40,
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .footer-bar-text': {
        color: palette.text.primary,
      },
      '& .footer-bar': {
        background: palette.background.primary,
      },
      '& .savings-contact-card': {
        padding: '0px 60px !important',
        background: palette.background.footer,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-title': {
        fontWeight: 'normal',
      },
      '& .hero-static-subtitle': {
        color: palette.text.secondary,
      },
      '& .hero-static-bg': {
        background: palette.background.footer,
      },
      '& .primary-static-button': {
        background: palette.text.highlight,
        border: `1px solid ${palette.text.primary}`,
        color: palette.text.primary,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        background: palette.background.light,
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.primary.main}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.divider,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
      '& .hero-static-bg': {
        background: `${palette.background.footer} !important`,
      },
      '& .react-multi-carousel-dot button': {
        background: palette.primary.main,
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, & .hero-header-subtitle': {
        textAlign: 'center',
      },
      '& .header-container': {
        justifyContent: 'center',
        margin: '0',
      },
      '@media(max-width: 900px)': {
        '& .section': {
          marginLeft: 0,
        },
      },
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },
    '& .faq-contact-section': {
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'auto',
        fontWeight: 'bold',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
      '& .contact-img-wrapper': {
        width: '84px',
        maxWidth: '84px',
      },
      '& .provider-contact-link': {
        fontSize: 20,
        fontWeight: 'bold',
      },
      '& .provider-contact-details': {
        color: palette.text.secondary,
        fontWeight: 400,
      },
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.primary.main,
      },
      '& .stepperIconActive': {
        color: `${palette.primary.main} !important`,
        '& .stepperIconText': {
          fill: palette.text.highlight,
        },
      },
      '& .stepperIconRoot': {
        color: 'transparent',
        borderColor: palette.primary.main,
        '& .stepperIconText': {
          fill: palette.primary.main,
        },
      },
      '& .stepperIconCompleted': {
        color: palette.primary.main,
      },
    },

    /* Footer style */
    '& .footer-wrapper': {
      background: palette.text.highlight,
      borderTop: `1px solid ${palette.divider}`,
      color: palette.text.primary,
      '& .footer-link, .copyrights-footer-link': {
        color: palette.text.primary,
      },
      '& .copyrights-footer': {
        borderTop: `1px solid ${palette.divider}`,
      },
    },
  },
};